import { render, staticRenderFns } from "./baseSetting.vue?vue&type=template&id=1f1e6307&scoped=true"
import script from "./baseSetting.vue?vue&type=script&lang=js"
export * from "./baseSetting.vue?vue&type=script&lang=js"
import style0 from "./baseSetting.vue?vue&type=style&index=0&id=1f1e6307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e6307",
  null
  
)

export default component.exports